import {Translator, useI18n} from '@logistics-frontend/core/i18n'
import {useTariff} from '@yandex-taxi/react-integration-api'
import React, {useMemo} from 'react'
import {Helmet} from 'react-helmet-async'

import {useConfig} from 'src/config'

import {classes} from './classes'
import {useSelectedCargoRequirement} from './hooks'

type IsString = (v?: unknown) => v is string

const defaultMessage = 'Яндекс Доставка — сервис быстрой доставки'

function getFirstTranslation(t: Translator, keys: string[]): string | undefined
function getFirstTranslation(t: Translator, keys: string[], defaultValue: string): string
function getFirstTranslation(t: Translator, keys: string[], defaultValue?: string): string | undefined {
  if (keys.length > 0) {
    const key = keys.join('.')

    return t(key, {fallBackToKey: false}) || getFirstTranslation(t, keys.slice(0, -1), defaultValue as string)
  }

  return defaultValue
}

function Title(): React.ReactElement {
  const t = useI18n()
  const [{value: tariff}] = useTariff()
  const cargoType = useSelectedCargoRequirement()
  const {zoneName} = useConfig().initialProps
  const {headTitle, headDescription, pageTitle} = useMemo(() => {
    const keys: string[] = [zoneName, tariff, cargoType].filter(Boolean as unknown as IsString)

    return {
      // возможные ключи:
      //   `page.title`
      //   `page.title.${tariff}`
      //   `page.title.${zoneName}`
      //   `page.title.${zoneName}.${tariff}`
      //   `page.title.${zoneName}.${tariff}.${cargoType}`
      headTitle: getFirstTranslation(t, ['page.title'].concat(keys), defaultMessage),
      // аналогично для описания
      headDescription: getFirstTranslation(t, ['page.meta.description'].concat(keys), defaultMessage),
      pageTitle: getFirstTranslation(t, ['page.h1'].concat(keys)),
    } as const
  }, [cargoType, t, tariff, zoneName])

  return (
    <>
      <Helmet>
        <title>{headTitle.trim()}</title>
        <meta content={headDescription.trim()} name="description" />
      </Helmet>
      {pageTitle && <h1 className={classes.root}>{pageTitle}</h1>}
    </>
  )
}

export default React.memo(Title)
